import React from "react";
import { TriangleAlert, CalendarClock, Droplet, MapPin, ThermometerSnowflake, Wrench } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const warningSigns = [{
  title: "Aging Roof Systems",
  description: "South Florida's intense sun and seasonal storms accelerate shingle and tile degradation. Roofs over 15 years old often show significant wear that can lead to water intrusion.",
  icon: CalendarClock
}, {
  title: "Electrical Hazard Issues",
  description: "Older homes frequently feature outdated panels or aluminum wiring. These systems struggle with modern power demands and pose significant fire risks in our humid environment.",
  icon: TriangleAlert
}, {
  title: "Plumbing Corrosion",
  description: "Local water conditions and humidity may contribute to deterioration in older plumbing materials. Visible corrosion or active leakage may indicate the need for further evaluation.",
  icon: Droplet
}, {
  title: "HVAC Salt Air Damage",
  description: "Coastal salt air causes rapid corrosion of exterior condenser coils. Without specialized coatings, systems often fail prematurely, losing efficiency and cooling capacity.",
  icon: Wrench
}, {
  title: "High Humidity Impact",
  description: "Improper ventilation or failing seals allow moisture to build up, leading to organic growth and compromised indoor air quality—a common challenge in our tropical climate.",
  icon: ThermometerSnowflake
}, {
  title: "South Florida Specifics",
  description: "From aging roof coverings to corrosion and moisture exposure, South Florida properties present regional conditions that require careful documentation of visible and accessible components.",
  icon: MapPin,
  highlight: true
}];
export default function SignsYouNeedWaterHeaterReplacement() {
  return <section data-section-id="242731" id="common-issues-found-in-south-florida-homes" className="py-16 md:py-24 bg-background text-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold font-default text-primary mb-4">
            Common Issues Found in South Florida Homes
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            South Florida’s climate can accelerate wear on roofing, electrical, plumbing, and HVAC components. A 4-Point Inspection may help document visible concerns in these systems for the insurance carrier’s review.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {warningSigns.map((sign, index) => {
          const Icon = sign.icon;
          return <Card key={index} data-index={index} className={`h-full transition-shadow hover:shadow-lg ${sign.highlight ? 'border-primary/50 bg-primary/5' : 'border-border bg-card'}`}>
                <CardHeader>
                  <div className={`w-12 h-12 rounded-lg flex items-center justify-center mb-4 ${sign.highlight ? 'bg-primary text-primary-foreground' : 'bg-secondary/10 text-secondary'}`}>
                    <Icon className="w-6 h-6" />
                  </div>
                  <CardTitle className="text-xl font-default text-card-foreground">
                    {sign.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base text-muted-foreground font-default">
                    {sign.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>

        <div className="flex justify-center">
          <Button asChild size="lg" className="font-default text-base px-8 bg-primary hover:bg-primary/90 text-primary-foreground shadow-md">
            <Link to="https://trusted-fl.com/#schedule-your-inspection">
              Book Your Inspection Now
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}